import './DelegateModal.scss';
import Modal from './Modal';
import Spinner from './Spinner';
import { connect } from 'react-redux';
import { store } from '../state';
import { delegate } from '../state/actions/Metamask';
import { useEffect } from 'react';
import cx from 'classnames';

const DelegateModal = props => {
  const { address, provider, onClose, isDelegating, isDelegated, errMsg } = props;

  useEffect(() => {
    let id;
    if (isDelegated) {
      id = setTimeout(() => { onClose() }, 500)
    }
    return () => clearTimeout(id);
  }, [isDelegated, onClose])

  const handleDelegate = () => {
    if (isDelegated) return;
    store.dispatch(delegate(address, provider));
  }

  return <Modal className="delegate-modal" onClose={onClose}>
    <div className="modal-title">Delegate TDrop Vote</div>
    <div className="modal">
      <div className='delegate-modal__address'>{address}</div>
      {errMsg && <div className='text-danger'>{errMsg}</div>}
      {isDelegating ? <div className='delegate-modal__button in-process'>
        <Spinner className='xs' />
        Delegating......
      </div> :
        <div className={cx('delegate-modal__button')} onClick={handleDelegate}>
          {isDelegated ? 'DELEGATED' : 'DELEGATE'}
        </div>}
    </div>
  </Modal>
}


const mapStateToProps = state => ({
  address: state.metamask.address,
  provider: state.metamask.provider,
  isDelegating: state.metamask.isDelegating,
  isDelegated: state.metamask.isDelegated,
  errMsg: state.metamask.errMsg
});

export default connect(mapStateToProps)(DelegateModal);